// Prefer env base; default to production base if missing
const envBase = (typeof process !== 'undefined' && process.env && process.env.GATSBY_API_BASE_URL) || "https://server.runity.com.ar/dev/api";
export const API_BASE = envBase.replace(/\/$/, "");

// Paths are relative to API_BASE which already includes /api
export const LOGIN_EMAIL = "/auth/login";
export const LOGIN_GOOGLE = "/auth/login-gmail";
export const LOGOUT = "/auth/logout";
export const ME = "/account/me";

export const url = (path) => `${API_BASE}${path}`;
